








































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import CampaignApi from '@/services/rest/bemob/campaign';
import Vue from 'vue';
import NoTagFound from '@/views/reports/views/no-tag-found.vue';
import CustomConversionsApi from '@/services/rest/bemob/custom-conversions';
import AffiliateNetworkAPI from '@/services/rest/bemob/affiliate-network';

@Component({
  components: {
    NoTagFound,
    FormOverlay,
    DialogForm,
    HeaderButtons
  }
})
export default class CampaignLinksDialog extends Vue {
  @Prop({ default: {} })
  data: any;
  campaignApi: CampaignApi = new CampaignApi();
  affiliateNetworkApi: AffiliateNetworkAPI = new AffiliateNetworkAPI();
  customConversionsApi: CustomConversionsApi = new CustomConversionsApi();
  landingItems=[]
  offerItems=[]
  trackCustomConversionsSwitcher=false;
  customConversionsItems=[]
  
  selectedLinkMode = 'postbackUrl'
  linkModes = [{
    id:'postbackUrl',
    name: this.t('Postback URL')
  },{
    id:'conversionPixelUrl',
    name: this.t('Conversion Pixel URL')
  },{
    id:'conversionPixel',
    name: this.t('Conversion Pixel')
  },{
    id:'conversionScript',
    name: this.t('Conversion Script')
  },{
    id:'postbackUrlTxt',
    name: this.t('Postback URL (for TXT response)')
  }]
  
  form={
    trackingDomainId:this.campaign.trackingDomainId || this.$store.state.user.trackingDomainId,
    offer:null,
    landing:null,
    payout:null,
    txid:null,
    status:null,
    eid:null,
    trackCustomConversions:{
      values:[]
    },
    trackCustomConversionsValue:'',
    customs:[''],
  }as{
    offer:Offer,
    landing:Landing,
    payout:string,
    trackingDomainId:string,
    txid:string,
    status:string,
    eid:string,
    trackCustomConversions: { 
      values:string[]
    },
    trackCustomConversionsValue:string,
    customs:string[],
  }
  
  get campaign(){
    return this.data.campaign;
  }
  
  trackCustomConversionsChange(){
    return this.form.trackCustomConversionsValue = this.form.trackCustomConversions.values[0];
  }

  @Watch('form.offer', {immediate: true})
  onOfferChange(value: string) {
    if(this.affiliateNetworkOfSelectedOffer){
      this.form.payout = this.affiliateNetworkOfSelectedOffer?.payoutPlaceholder
      this.form.txid = this.affiliateNetworkOfSelectedOffer?.transactionIdPlaceholder
      this.form.status = this.affiliateNetworkOfSelectedOffer?.statusPlaceholder
    }else{
      this.form.payout = ''
      this.form.txid = ''
      this.form.status = ''
    }
  }
  
  get finalPostbackUrl(){
    let trackingDomain = this.$store.getters.cache.trackingDomainsObject[this.form.trackingDomainId]
    const domain = `${trackingDomain.httpsAvailable ? 'https' : 'http'}://${trackingDomain.domain}`
    const searchParams = [`caid=${this.campaign.id}`]
    if(this.campaign.destinationType==='flow'){
      searchParams.push(`flid=${this.campaign.flow.id}`)
    }
    if(this.form.landing){
      searchParams.push(`lpid=${this.form.landing.id}`)
    }
    if(this.form.offer){
      searchParams.push(`oid=${this.form.offer.id}`)
    }
    if(this.form.eid){
      searchParams.push(`eid=${this.form.eid}`)
    }

    searchParams.push(`payout=${this.form.payout || 'OPTIONAL'}`)
    searchParams.push(`txid=${this.form.txid || 'OPTIONAL'}`)

    if(!this.trackCustomConversionsSwitcher){
      searchParams.push(`status=${this.form.status || 'OPTIONAL'}`)
    }
    if(this.trackCustomConversionsSwitcher){
      searchParams.push(`cet=${this.form.trackCustomConversionsValue}`)
    }
    this.form.customs.forEach((item,index)=>{
      if(item){
        searchParams.push(`custom${index+1}=${item}`)
      }
    })

    const searchParamsString = searchParams.join('&')
   
    switch (this.selectedLinkMode){
      case 'postbackUrl':
        return `${domain}/postback?attribution=cid-caid&${searchParamsString}`;
      case 'conversionPixelUrl':
        return `${domain}/conversion.gif?attribution=cid-caid&${searchParamsString}`;
      case 'conversionPixel':
        return `<img src="${domain}/conversion.gif?attribution=cid-caid&${searchParamsString}" width="1" height="1" border="0" alt="" />`;
      case 'conversionScript':
        return `<script async type="text/javascript" src="${domain}/conversion.js?attribution=cid-caid&${searchParamsString}"></sc`+`ript>`;
      case 'postbackUrlTxt':
        return `${domain}/conversion.txt?attribution=cid-caid&${searchParamsString}`;
    }
  }

  close() {
    this.$emit('close');
  }

  deleteCustomRow() {
    this.form.customs.pop()
  }

  addCustomRow() {
    this.form.customs.push('')
  }
  
  calculateOffersAndLandings(){
    let dataSource;
    if(this.campaign.destinationType==='url'){
      return;
    }
    if(this.campaign.destinationType==='flow'){
      dataSource = this.campaign.flow
    }
    if(this.campaign.destinationType==='flowInline'){
      dataSource = this.campaign.flowInline
    }

    let offersWithDuplicates=[]
    let landingsWithDuplicates=[]
    dataSource.rules.forEach(rules=>{
      rules.paths.forEach(path=>{
        offersWithDuplicates = offersWithDuplicates.concat(path.offers)
        if(!path.directLinking){
          landingsWithDuplicates = landingsWithDuplicates.concat(path.landings)
        }
      })
    })

    const offersWithDuplicatesStr = offersWithDuplicates.map(item=>JSON.stringify(item));
    const landingsWithDuplicatesStr = landingsWithDuplicates.map(item=>JSON.stringify(item));
    const offerUniqueSet = new Set(offersWithDuplicatesStr);
    const landingsUniqueSet = new Set(landingsWithDuplicatesStr);
    this.offerItems = Array.from(offerUniqueSet).map(item=>JSON.parse(item));
    this.landingItems = Array.from(landingsUniqueSet).map(item=>JSON.parse(item));
    
    this.form.offer = this.offerItems[0]
    this.form.landing = this.landingItems?.[0]
  }
  
  get affiliateNetworkOfSelectedOffer(){
    return this.$store.getters.cache.affiliateNetworksObject?.[this.form.offer?.affiliateNetworkId]?.affiliateNetworkTemplate || {}
  }
  
  async mounted(){
    this.calculateOffersAndLandings()
    this.customConversionsApi.get({status:'active'}).then((data:any)=>{
      this.customConversionsItems = data.filter(item=>item.status === 'active')
      this.form.trackCustomConversions = this.customConversionsItems[0]
      this.form.trackCustomConversionsValue = this.form.trackCustomConversions.values[0]
    });


    if(!this.$store.state.cache.affiliateNetworks.isUploaded){
      await this.affiliateNetworkApi.populateStoreCache()
    }
  } 
  
  
}
